<template>
  <DialogBox class="jat-modal" title="JOB ADVANCEMENT TREE">
    <template #body>
      <div id="jat-table" :style="{ width: `${tableData.length * 157 + 87}px` }">
        <div class="jat-row">
          <div>Level</div>
          <div v-for="item in tableData" :key="item.level">
            {{ item.level }}
          </div>
        </div>
        <div class="jat-row">
          <div>Skills</div>
          <div v-for="item in tableData" :key="item.skill">
            {{ item.skill }}
          </div>
        </div>
        <div class="jat-row">
          <div></div>
          <div class="jat-image">
            <img :alt="characterData.name" :src="characterData.jobAdvancementTree" />
          </div>
        </div>
      </div>
    </template>
  </DialogBox>
</template>
<script setup lang="ts">
  import { computed, PropType } from 'vue'
  import { ICharacterCdn } from '@/store/ClassesJobs'

  interface TableItem {
    level: string
    skill: string
  }

  const props = defineProps({
    characterData: {
      type: Object as PropType<ICharacterCdn>,
      required: true,
    },
  })

  const isDualBlade = computed<boolean>(() => props.characterData.name.toLowerCase().replace(/ /g, '') === 'dualblade')
  const isZero = computed<boolean>(() => props.characterData.name.toLowerCase().replace(/ /g, '') === 'zero')
  const tableData = computed<TableItem[]>(() =>
    isDualBlade.value ? dualBladeTableData : isZero.value ? zeroTableData : defaultTableData
  )

  const defaultTableData: TableItem[] = [
    { level: '1', skill: 'Beginner' },
    { level: '10', skill: '1st Job' },
    { level: '30', skill: '2nd Job' },
    { level: '60', skill: '3rd Job' },
    { level: '100', skill: '4th Job' },
    { level: '200', skill: '5th Job' },
    { level: '260+', skill: '6th Job' },
  ]
  const dualBladeTableData: TableItem[] = [
    { level: '1', skill: 'Beginner' },
    { level: '10', skill: '1st Job' },
    { level: '20', skill: '1.5 Job' },
    { level: '30', skill: '2nd Job' },
    { level: '45', skill: '2.5 Job' },
    { level: '60', skill: '3rd Job' },
    { level: '100', skill: '4th Job' },
    { level: '200', skill: '5th Job' },
    { level: '260+', skill: '6th Job' },
  ]
  const zeroTableData: TableItem[] = [
    { level: '100', skill: '4th Job' },
    { level: '200', skill: '5th Job' },
    { level: '260+', skill: '6th Job' },
  ]
</script>
<style lang="scss" scoped>
  #jat-table {
    margin: 10px 0 20px;
    color: #5a5753;
    font-weight: bold;
    font-size: 18px;
    font-family: 'Glegoo';
    height: 250px;
    display: flex;
    flex-direction: column;
    .jat-row {
      display: flex;
      height: 60px;
      &:first-child {
        div {
          border-top: 1px solid #e9eaee;
        }
      }
      &:nth-child(even) {
        div {
          background-color: #fdfdfd;
        }
      }
      &:nth-child(odd) {
        div {
          background-color: #f9f9f9;
        }
      }
      &:last-child {
        height: 130px;
        :last-child {
          width: 100%;
        }
      }
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 157px;
        border-bottom: 1px solid #e9eaee;
        img {
          margin: 0 16px;
        }
        &:first-child {
          min-width: 87px;
          border-right: 1px solid #e9eaee;
        }
      }
    }
  }
</style>
<style lang="scss">
  .jat-modal {
    .v-overlay__content {
      width: auto !important;
    }
    .dialog-body {
      padding: 0 !important;
    }
  }
</style>
